// styles
import classes from "./styles.module.css";

export default function StatisticInfo({
  title,
  value,
  valueStyles = { color: "#0F172B", background: "#0000", padding: "5px 0px" },
}) {
  return (
    <div className={classes.root}>
      <p className={classes.title}>{title}</p>
      <p className={classes.value} style={valueStyles}>
        {value}
      </p>
    </div>
  );
}
